import React from 'react'
import { Container, Grid } from '@material-ui/core'
import { HeaderHLPure } from '../../pures'
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout'
import './user-administration-new.css'
import UserAdministrationList from './user-administration-list'
import UserAdministrationUserData from './user-administration-user-data'
import UserAdministrationUserRoles from './user-administration-user-roles'
import UserAdministrationUserPermissions from './user-administration-user-permissions'
import UserAdministrationUseAssistants from './user-administration-user-assistants'
import { useState } from 'react'

const OfferView = (props) => {
  const [selected, setSelected] = React.useState(0)
  const [editingTab, setEditingTab] = useState(null)

  const {
    t,
    selectedUser,
    setSelectedUser
  } = props

  const handleSelect = (e) => {
    setSelected(e.selected)
    // Resetea el estado de edición al cambiar de pestaña
    setEditingTab(null)
  }

  const handleBack = () => {
    setSelectedUser({})
    setSelected(0)
    setEditingTab(null)
  }

  const getTabProps = (tabName) => ({
    isEditing: editingTab === tabName,
    setIsEditing: (value) => setEditingTab(value ? tabName : null)
  })

  return (
    <Container className='view-container userAdministrationView'>
      <Grid container spacing={2}>
        <Grid item xs={12} className='header-inbox'>
          <HeaderHLPure title={t('title')} />
        </Grid>

        {
          !selectedUser?.name ?
            <UserAdministrationList setData={setSelectedUser} {...props} />
            :
            <>
              <Grid item xs={12}>
                <TabStrip
                  selected={selected}
                  onSelect={handleSelect}
                  tabPosition={'left'}
                >
                  <TabStripTab title={t('generalData')} disabled={editingTab !== null} >
                    <UserAdministrationUserData t={t} selectedUser={selectedUser} handleBack={handleBack} />
                  </TabStripTab>
                  <TabStripTab title={t('roles')} disabled={editingTab !== null && editingTab !== 'roles'}>
                    <UserAdministrationUserRoles
                      t={t}
                      roles={props.roles}
                      selectedUser={selectedUser}
                      handleBack={handleBack}
                      {...getTabProps('roles')}
                      updateUserRoles={props.updateUserRoles}
                    />
                  </TabStripTab>
                  <TabStripTab title={t('permissions')} disabled={editingTab !== null && editingTab !== 'permissions'}>
                    <UserAdministrationUserPermissions
                      t={t}
                      permissions={selectedUser.permissions || []}
                      userId={selectedUser.id}
                      handleBack={handleBack}
                      {...getTabProps('permissions')}
                      updateUserPermissions={props.updateUserPermissions}
                    />
                  </TabStripTab>
                  <TabStripTab title={t('assistants')} disabled={editingTab !== null && editingTab !== 'assistants'}>
                    <UserAdministrationUseAssistants
                      t={t}
                      selectedUser={selectedUser}
                      handleBack={handleBack}
                      {...getTabProps('assistants')}
                      getAvailableAssistants={props.getAvailableAssistants}
                      getAssignedAssistants={props.getAssignedAssistants}
                      assignAssistant={props.assignAssistant}
                    />
                  </TabStripTab>
                </TabStrip>
              </Grid>
            </>
        }
      </Grid>
    </Container>
  )
}

export { OfferView as default }